import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import * as JsBarcode from 'jsbarcode';
import { QRCodeToDataURLOptions } from 'qrcode';
import { EtiquetaMascarello } from 'src/app/_models/etiqueta-mascarello';

@Component({
  selector: 'app-etiqueta-mascarello',
  templateUrl: './etiqueta-mascarello.component.html',
  styleUrls: ['./etiqueta-mascarello.component.scss']
})
export class EtiquetaMascarelloComponent implements OnChanges {

  @Input()
  etiqueta: EtiquetaMascarello | null = null;

  @Input()
  largura: number | null = null;

  @Input()
  altura: number | null = null;

  menorMedida: number | null = null;

  barcodeConfig: JsBarcode.Options | null = null;

  qrCodeConfig: QRCodeToDataURLOptions | null = null;

  constructor () { }

  ngOnChanges (changes: SimpleChanges): void {

    if (
      changes['largura'] ||
      changes['altura']
    )
      this.tratarMudancaDeTamanho();
  }

  private tratarMudancaDeTamanho (): void {

    this.menorMedida = this.largura! > this.altura! ? this.altura : this.largura;

    this.barcodeConfig = {
      margin: 0,
      width: Math.ceil(this.menorMedida! / 300),
      height: Math.floor(this.menorMedida! * 0.08),
      displayValue: false
    };

    this.qrCodeConfig = {
      margin: 0,
      scale: Math.floor(this.altura! / 130)
    }
  }
}
